import React from 'react';
import { Progress } from '@/components/ui/progress';
import { Badge } from '@/components/ui/badge';
import { BarChart3 } from 'lucide-react';

interface UsageIndicatorProps {
  currentUsage: number;
  limit: number;
  className?: string;
}

const UsageIndicator: React.FC<UsageIndicatorProps> = ({ 
  currentUsage, 
  limit, 
  className = '' 
}) => {
  const percentage = (currentUsage / limit) * 100;
  const remaining = limit - currentUsage;
  
  const getVariant = () => {
    if (percentage >= 90) return 'destructive';
    if (percentage >= 75) return 'secondary';
    return 'default';
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <BarChart3 className="h-4 w-4 text-muted-foreground" />
      <div className="flex-1 space-y-1">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Monthly analyses</span>
          <Badge variant={getVariant()} className="text-xs">
            {currentUsage}/{limit}
          </Badge>
        </div>
        <Progress value={percentage} className="h-2" />
        <div className="text-xs text-muted-foreground">
          {remaining > 0 ? `${remaining} remaining` : 'Limit reached'}
        </div>
      </div>
    </div>
  );
};

export default UsageIndicator;